import { useQuery } from "@apollo/client";
import { userPhoneVerifyQuery } from "../queries/userPhoneVerifyQuery";

export const useUserPhoneVerify = () => {
  const { data, loading } = useQuery(userPhoneVerifyQuery, {
    fetchPolicy: "no-cache"
  });

  const user = data?.user;

  return {
    hasUserPhone: Boolean(user?.phone),
    phoneNumber: user?.phone,
    isPhoneVerified: user?.phone_verified,
    isLoaded: Boolean(user),
    loading
  };
};
